module.exports = __webpack_public_path__ + "static/img/struct4.65a91b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/struct4.png
// module id = fjF+
// module chunks = 1